import { rem } from 'polished'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import { mediaQueryUp } from 'components/utils/breakpoint'

const TileContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  background-color: ${props => props.theme.palette.neutral.default.eight};
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
  border-radius: ${props => props.theme.borderRadius.S};
  overflow: hidden;

  ${mediaQueryUp.tablet} {
    grid-template-columns: ${rem(300)} 1fr;
  }
`

const ImagePlaceholder = styled(LoadingBox)`
  height: ${rem(200)};

  ${mediaQueryUp.tablet} {
    height: 100%;
    min-height: ${rem(250)};
  }
`

const ContentSection = styled(Group)`
  padding: ${rem(20)};
`

const ButtonPlaceholder = styled(LoadingBox)`
  width: ${rem(120)};
  height: ${rem(40)};
  border-radius: ${rem(8)};
`

function DrawerHotelTileSkeleton() {
  return (
    <TileContainer data-testid="drawer-hotel-tile-skeleton">
      <ImagePlaceholder />
      <ContentSection direction="vertical" gap={16}>
        <Group direction="vertical" gap={4}>
          <TextLoadingBox typography="body-small" width="40%" />
          <TextLoadingBox typography="heading5" width="75%" />
        </Group>
        <Group direction="vertical" gap={4}>
          <TextLoadingBox typography="body-medium" width="60%" />
          <TextLoadingBox typography="body-medium" width="50%" />
          <TextLoadingBox typography="body-medium" width="45%" />
        </Group>
        <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="end">
          <Group direction="vertical" gap={2}>
            <TextLoadingBox typography="body-small" width={80} />
            <TextLoadingBox typography="heading4" width={100} />
          </Group>
          <ButtonPlaceholder />
        </Group>
      </ContentSection>
    </TileContainer>
  )
}

export default DrawerHotelTileSkeleton
